/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React from "react";
import {NavLink} from "react-router-dom";


const SideBar = () =>{
    return(
        <>
            <div id="layoutSidenav_nav">
                <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">

                    <div className="sb-sidenav-menu">

                        <div className="nav">
                            <div className="sb-sidenav-menu-heading">Core</div>
                            <NavLink className="nav-link" to="/">
                                <div className="sb-nav-link-icon"><i className="fas fa-truck-pickup"/></div>
                                Provider Dashboard
                            </NavLink>
                            <div className="sb-sidenav-menu-heading">Order Management</div>
                            <NavLink className="nav-link" to="/order-list">
                                <div className="sb-nav-link-icon"><i className="fas fa-truck-pickup"/></div>
                               My Order List
                            </NavLink>
                            <NavLink activeClassName={'active'} className="nav-link" to="/paypal-settings">
                                <div className="sb-nav-link-icon"><i className="fas fa-user"/></div>
                                Paypal Settings
                            </NavLink>
                            <NavLink activeClassName={'active'} className="nav-link" to="/revenue">
                                <div className="sb-nav-link-icon"><i className="fas fa-user"/></div>
                                Revenue Details
                            </NavLink>
                        </div>
                    </div>
                    <div className="sb-sidenav-footer">
                        <div className="small">Logged in as:</div>
                        {localStorage.name != undefined? localStorage.name : null}
                    </div>
                </nav>
            </div>
        </>
    )
}
export default SideBar
